export const REDIRECT_COOKIE = 'umr'; // user mapping redirect
export const MANDATE_KEY = 'mnd'; // mandatory mobile mapping
export const ALT_TEXT = 'background-creative';
